import getModulesNames  from '@/getModulesNames.helper';

import ActiveModule     from './active/active';
import NavbarModule     from './navbar/navbar';
import AuthModule       from './auth/auth';
import TranslatesModule from './translates/translates';
import UtilityModule    from './utility/utility';
import BookingModule    from './booking/booking';
import ErrorsModule     from './errors/errors';

import AdminModule      from './admin/admin';

const ComponentsModule = angular
  .module('app.components', getModulesNames([
    ActiveModule,
    NavbarModule,
    AuthModule,
    TranslatesModule,
    UtilityModule,
    BookingModule,
    AdminModule,
    ErrorsModule
  ]));

export default ComponentsModule;



/** WEBPACK FOOTER **
 ** ./frontend/components/components.js
 **/